import { useState } from 'react'
import BannerLogin from '../../../component/BannerLogin/BannerLogin'
import { getApiUrl } from '../../../api/api'
import './DangNhap.scss'
import { saveTolocalstorage } from '../../../component/MaHoaDuLieu/MaHoaDuLieu'
import Notify from '../../../component/Notify/Notify'

function DangNhap ({ onClose }) {
  const [isPassword, setisPassword] = useState(true)
  const [notifyMessage, setNotifyMessage] = useState("");
  const [notifyType, setNotifyType] = useState("error");
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  })
  const [notiMessage, setNotiMessage] = useState('')
  const [type, settype] = useState('')

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target
    let newValue = type === 'checkbox' ? checked : value
    if (name === 'username') {
      newValue = newValue.replace(/\s/g, '')
    }
    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }))
  }

  const handleLogin = async e => {
    e.preventDefault()
    const username = formData.username.trim()
    const password = formData.password.trim()

    if (!username || !password) {
      setNotifyMessage("Vui lòng nhập tên đăng nhập và mật khẩu!");
      setNotifyType("error");
      return
    }

    try {
      const res = await fetch(`${getApiUrl('backend')}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      })

      const data = await res.json()
      if (data.error) {
        setNotiMessage(data.error)
        settype('error')
        return
      }

      localStorage.setItem('dangnhap', 'true')
      saveTolocalstorage('data_u', JSON.stringify(data))
      if (data.token) {
        localStorage.setItem('token', data.token)
      }

      setNotifyMessage("Đăng nhập thành công");
      setNotifyType("success");
      onClose?.()
      window.location.reload()
    } catch (err) {
      console.error('Lỗi đăng nhập:', err)
      setNotiMessage('Có lỗi xảy ra, vui lòng thử lại!')
      settype('error')
    }
  }

  return (
    <>
      {notiMessage && (
        <Notify
          message={notiMessage}
          setcontent={setNotiMessage}
          type={type}
        />
      )}

      <div className='login_form_mobile'>
        <BannerLogin />
        <form onSubmit={handleLogin}>
          <div className='login_form_input_item'>
            <div className='input_wrapper'>
              <div className='icon_account_input icon_input'></div>
              <input
                type='text'
                className='input_login_form'
                name='username'
                placeholder='Tên đăng nhập'
                value={formData.username}
                onChange={handleInputChange}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault()
                  }
                }}
                required
              />
            </div>
            <div className='input_wrapper'>
              <div className='icon_password_input icon_input'></div>
              <input
                type={isPassword ? 'password' : 'text'}
                className='input_login_form'
                name='password'
                placeholder='Mật khẩu'
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <div
                className='icon-eyes-container'
                onClick={() => setisPassword(!isPassword)}
              >
                <i className='iconeyes_svg'>
                  {isPassword ? (
                    // icon ẩn
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='100%'
                      height='100%'
                      viewBox='0 0 20 20'
                      fill='none'
                    >
                      <path
                        d='M2.72727 4.77405L3.65818 3.83331L15.8182 16.2185L14.8945 17.1666L12.6545 14.8852C11.8182 15.1666 10.9309 15.3148 10 15.3148C6.36364 15.3148 3.25818 13.0111 2 9.75924C2.50182 8.45553 3.30182 7.30739 4.32 6.39628L2.72727 4.77405ZM10 7.53702C11.205 7.53702 12.1818 8.53194 12.1818 9.75924C12.1818 10.0185 12.1382 10.2703 12.0582 10.5L9.27273 7.66294C9.49818 7.58146 9.74545 7.53702 10 7.53702ZM10 4.20368C13.6364 4.20368 16.7418 6.50739 18 9.75924C17.4036 11.3 16.3927 12.6333 15.0909 13.6037L14.0582 12.5444C15.0473 11.8481 15.8618 10.9 16.4145 9.75924C15.2145 7.27035 12.7345 5.68516 10 5.68516C9.20727 5.68516 8.42909 5.8185 7.70182 6.05554L6.58182 4.9222C7.62909 4.46294 8.78545 4.20368 10 4.20368ZM3.58545 9.75924C4.78545 12.2481 7.26545 13.8333 10 13.8333C10.5018 13.8333 10.9964 13.7815 11.4545 13.6778L9.79636 11.9815C8.75636 11.8704 7.92727 11.0259 7.81818 9.96665L5.34545 7.44072C4.62545 8.07035 4.02182 8.85554 3.58545 9.75924Z'
                        fill='currentColor'
                      ></path>
                    </svg>
                  ) : (
                    // icon hiện
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='100%'
                      height='100%'
                      viewBox='0 0 20 20'
                      fill='none'
                    >
                      <g>
                        <path
                          d='M10.01 11.89C11.214 11.89 12.19 10.914 12.19 9.71003C12.19 8.50605 11.214 7.53003 10.01 7.53003C8.80602 7.53003 7.83 8.50605 7.83 9.71003C7.83 10.914 8.80602 11.89 10.01 11.89Z'
                          fill='currentColor'
                        ></path>
                        <path d='M16.39 12.37C16.51 12.23 16.65 12.09 16.76 11.94C16.93 11.72 17.07 11.49 17.22 11.25...'></path>
                      </g>
                    </svg>
                  )}
                </i>
              </div>
            </div>
          </div>
          <button type='submit' className='login_btn_mobile'>
            Đăng Nhập
          </button>
        </form>
      </div>
    </>
  )
}

export default DangNhap
